import { render, staticRenderFns } from "./CardPhoto.vue?vue&type=template&id=96e7157c&scoped=true&"
import script from "./CardPhoto.vue?vue&type=script&lang=js&"
export * from "./CardPhoto.vue?vue&type=script&lang=js&"
import style0 from "./CardPhoto.vue?vue&type=style&index=0&id=96e7157c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e7157c",
  null
  
)

export default component.exports